import React from 'react';
import ChartWrapper from './ChartWrapper';
import { getOptions } from './utils';

const LocationChart = ({ data, mapData }) => {
    return <ChartWrapper data={data} mapData={mapData} getOptions={getOptions} />;
};

export default LocationChart;
